import { render, staticRenderFns } from "./GroupPanel.vue?vue&type=template&id=01349f22&scoped=true"
import script from "./GroupPanel.vue?vue&type=script&lang=js"
export * from "./GroupPanel.vue?vue&type=script&lang=js"
import style0 from "./GroupPanel.vue?vue&type=style&index=0&id=01349f22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01349f22",
  null
  
)

export default component.exports